import crypto from 'crypto';
import NodeRSA from 'node-rsa';
import CryptoJS from 'crypto-js';
import EncryptKey from '@/config';
import remoteConfig from '../remote-config';

// 新配置的接口走单独的中间件组，加密参数与旧接口不兼容
export const getEncryptConfig = (url: string) => {
  if (url.includes('/user/sec/fast-escrow')) {
    return EncryptKey.userSecConfig || EncryptKey;
  }
  return EncryptKey;
};

export function signature(data: Record<string, any>, url: string, encode = 'base64') {
  try {
    let hashString = '';
    const encryptConfig = getEncryptConfig(url);
    if (remoteConfig?.getValue('need_text_encoder') === true) {
      // 将数据转为JSON字符串并与密钥拼接
      const str = JSON.stringify(data, null, 0);
      // 使用crypto-js的UTF8编码处理字符串
      const utf8Str = CryptoJS.enc.Utf8.parse(str + encryptConfig.secretKey);
      // 计算SHA-256哈希
      const hash = CryptoJS.SHA256(utf8Str);
      // 获取十六进制哈希值
      hashString = hash.toString(CryptoJS.enc.Hex);
      console.log('the new signature for crypto-js');
    } else {
      const str = JSON.stringify(data) + encryptConfig.secretKey;
      const hash = crypto.createHash('sha256');
      hash.update(str);
      hashString = hash.digest('hex');
      console.log('the old signature');
    }
    const key = new NodeRSA(encryptConfig.publicKey, 'pkcs8-public', {
      encryptionScheme: 'pkcs1_oaep',
      signingScheme: 'pkcs1-sha1',
    });

    return key.encrypt(hashString, encode as NodeRSA.Encoding);
  } catch (error) {
    throw new Error('Sigature Error');
  }
}
